<template>
    <transition name="state" mode="out-in">
        <div class="state-wrapper" :key="stateKey">
            <StateLoading v-if="stateKey === 'loading'" />
            <StateEmpty v-else-if="stateKey === 'empty'" :subject="subject" />
            <slot v-else></slot>
        </div>
    </transition>
</template>

<script>
import StateLoading from '@/components/common/state/StateLoading.vue'
import StateEmpty from '@/components/common/state/StateEmpty.vue'

export default {
    name: 'State',
    components: {
        StateLoading,
        StateEmpty
    },
    computed: {
        stateKey() {
            if (this.isLoading) {
                return 'loading'
            }

            if (this.isEmpty) {
                return 'empty'
            }

            return 'ready'
        }
    },
    props: {
        isLoading: {
            type: Boolean,
            default: false
        },
        isEmpty: {
            type: Boolean,
            default: false
        },
        subject: {
            type: String,
            default: ''
        }
    }
}
</script>

<style scoped>
.state-wrapper {
    display: contents;
}

.state-enter-active,
.state-leave-active {
    transition: opacity 0.3s ease;
}

.state-enter-from,
.state-leave-to {
    opacity: 0;
}
</style>
